import { useState } from 'react'

import { NewReportForm } from './new-report-form'
import { ReportsList } from './reports-list'

export function Infestation() {
  const [openForm, setOpenForm] = useState(false)

  return (
    <>
      {openForm ? (
        <NewReportForm goBack={() => setOpenForm(false)} />
      ) : (
        <ReportsList openForm={() => setOpenForm(true)} />
      )}
    </>
  )
}
